var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPermissionsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00092 21.7979C9.10892 21.7979 10.0079 20.8999 10.0089 19.7919L10.0119 16.7277C10.0125 16.1324 10.3781 15.6113 10.8694 15.2751C11.4843 14.8543 12.0249 14.2801 12.4239 13.5139C13.3379 11.7599 13.1629 9.55592 11.9199 8.01792C9.88992 5.50692 6.09192 5.51292 4.07092 8.03592C2.83392 9.57892 2.66492 11.7839 3.58792 13.5329C3.98706 14.2898 4.52498 14.8597 5.13646 15.2779C5.62954 15.6152 5.99653 16.1384 5.99594 16.7358L5.99292 19.7869C5.99192 20.8969 6.89092 21.7979 8.00092 21.7979ZM8.00092 21.7979L-nan -nanCnan nan nan nan nan nanLnan nanCnan nan nan nan nan nanLnan nanCnan nan nan nan nan nanLnan nanCnan nan nan nan nan nanL8.00092 21.7979Z",
    stroke: "#15181E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.27355 11.1439C8.27355 10.9809 8.14155 10.8499 7.97955 10.8499C7.81655 10.8509 7.68555 10.9829 7.68555 11.1449C7.68555 11.3079 7.81755 11.4389 7.97955 11.4389C8.14155 11.4389 8.27355 11.3069 8.27355 11.1439Z",
    stroke: "#15181E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.263 6.42985C13.263 4.97585 12.085 3.79785 10.631 3.79785M8 10.8499V6.42985C8 4.97585 9.178 3.79785 10.631 3.79785M10.631 3.79785L-nan -nanCnan nan nan nan nan nanLnan nanCnan nan nan nan nan nanL10.631 3.79785Z",
    stroke: "#15181E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3984 7.46385L11.8484 7.01385C12.6294 6.23285 13.8954 6.23285 14.6764 7.01385L20.4134 12.7509C21.1944 13.5319 21.1944 14.7978 20.4134 15.5788L17.7664 18.2259C16.9854 19.0069 15.7194 19.0069 14.9384 18.2259L11.4854 14.7729",
    stroke: "#15181E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPermissionsIcon);
export default __webpack_public_path__ + "static/media/PermissionsIcon.6a7d40a92113d3d8f1027c4fa2440401.svg";
export { ForwardRef as ReactComponent };